import { useState } from "react";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";
import { LoadingSpinner, isUrdu } from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import useForm from "../../../shared/useForm";
import { ApiFinance } from "../ApiFinance";
const categoryValues = {
  category: "",
  code: "",
};

const AddFinanceCategory = ({ setAddModal, setReload, reload }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { errors, setErrors, values, handleInputChange } =
    useForm(categoryValues);
  const toggle = () => setAddModal(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.category = values.category
      ? ""
      : t("common_field_required_error");
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      ApiFinance()
        .AddFinanceCategory(values)
        .then((res) => {
          // swal({
          //   title: t("finance_finance_category_added"),
          //   className: GetSelectedLanguage() === "en" ? "" : "ur",
          //   icon: "success",
          //   buttons: "OK",
          // });
          setReload(!reload);
          setLoading(false);
          toggle();
        })
        .catch((err) => {
          setLoading(false);

          swal({
            title: err.message || "Something went wrong",
            text: err.response?.data || "",
            icon: "error",
            buttons: "OK",
          });
          toggle();
          console.error(err);
        });
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="finance_tab_finance_categories_add" />}
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <FormGroup>
                  <Label>
                    {<GetLanguageString props="finance_tab_category" />}
                  </Label>
                  <Input
                    autoFocus
                    type="text"
                    name="category"
                    className={
                      isUrdu(values.category) ? "ur no-drag" : "no-drag"
                    }
                    value={values.category}
                    onChange={handleInputChange}
                    {...(errors.category && { invalid: true })}
                  />
                  {errors.category && (
                    <FormFeedback>
                      <h4>{errors.category}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>{<GetLanguageString props="settings_code" />}</Label>
                  <Input
                    type="text"
                    name="code"
                    className={isUrdu(values.code) ? "ur no-drag" : "no-drag"}
                    value={values.code}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" type="submit">
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default AddFinanceCategory;
